// extracted by mini-css-extract-plugin
export var bodyRow = "_i5-d";
export var cardColumns = "_i5-e";
export var ellipsesOverflow = "_i5-2";
export var flatBottomCorners = "_i5-3";
export var flatTopCorners = "_i5-4";
export var headerActionsDropdown = "_i5-f";
export var headerBottomRow = "_i5-c";
export var headerTopRow = "_i5-b";
export var orderDetailsWrapper = "_i5-0";
export var orderInfoContainer = "_i5-1";
export var productDetails = "_i5-9";
export var productImage = "_i5-5";
export var responsiveTable = "_i5-8";
export var shipmentContainer = "_i5-a";
export var tableBottomLeft = "_i5-6";
export var tableBottomRight = "_i5-7";
export var trackingLink = "_i5-g";